export default __webpack_public_path__ + "static/media/2122 knife block B side.d8e54452.png";